// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eNq2i","largestCol":"styles_largestCol__1_TB3","smallestCol":"styles_smallestCol__3LMB0"};